import { useCallback } from 'react';
import { DirittoAppBridge } from 'libs/DirittoAppBridge';
import { useRouter } from 'next/navigation';
import { useClient } from 'ui-hooks/useClient';

export const useRouterBack = () => {
  const router = useRouter();
  const { isApp } = useClient();

  return useCallback(() => {
    if (isApp) {
      setTimeout(() => {
        DirittoAppBridge.historyBack();
      }, 0);
      return;
    }

    router.back();
  }, [isApp, router]);
};
